export default ".name::before {\n  content: \"Before: \";\n}\n\n.name::after {\n  content: '...';\n}\n"